<template>
    <div class="layout">
        <div class="layout__main">
            <AppCap
                class="layout__cap"
                :isHumburgerActive="isMenuOpen"
                :title="$route.meta.title || 'Oohdesk'"
                :hasLogo="true"
                view="transparent"
                @onHumburger="onHumburger"
            ></AppCap>
            <div class="layout__content">
                <AppMenu
                    v-show="isMenuOpen"
                    class="layout__menu"
                />
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import AppCap from './components/Cap'
import AppMenu from './components/Menu'

export default {
    name: 'DefaultLayout',
    components: {
        AppCap,
        AppMenu,
    },
    data() {
        return {
            isMenuOpen: false,
        }
    },
    methods: {
        onHumburger() {
            this.isMenuOpen = !this.isMenuOpen
            this.isFilterOpen = false
        }
    }
}
</script>

<style lang="scss" scoped>
.layout {
    height: 100vh;
    display: flex;

    .loading {
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }

    &__cap {
        flex-grow: 0;
        flex-shrink: 0;
        position: relative;
        z-index: 200;
    }

    &__main {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    &__content {
        position: relative;
        z-index: 100;
        width: 100%;
        height: 100%;
        background: #fff;
        overflow: hidden;
        padding: 10px 40px 40px 40px;
    }

    &__menu {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: #fff;
        z-index: 9999;
    }

    &__filter {
        padding: 40px;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: #fff;
        z-index: 9999;
        border-top: 1px solid #eee;
    }
}
</style>
